
import request from ".."
interface LoginResult {
    token: string
}
/** 用户信息 */
export interface UserInfo {
  tenantId: number;
  createBy: string;
  createTime: null;
  updateBy: null;
  updateTime: null;
  params: any;
  userId: number;
  weixinOpenId: null;
  weixinUnionId: null;
  deptId: null;
  userName: string;
  nickName: string;
  email: string;
  userType: string;
  inviteFlag: string;
  phonenumber: string;
  sex: string;
  avatar: string;
  salt: null;
  status: string;
  delFlag: string;
  loginIp: string;
  loginDate: string;
  dept: null;
  roles: Role[];
  postIds: any[];
  postId: null;
  roleId: null;
  signUpTimes: number;
  incomeAmount: number;
  accountAmount: number;
  freezeAmount: number;
  consultantFlag: null;
  vipLevel: number;
  rechargeAmount: number;
  rechargeType: null;
  referrerUserId: null;
  sourceShop: string;
  regionName: null;
  productBalance: number;
  productAccount: string;
  address: string;
  userTypes: any[];
  consultantRank: number;
  consultantRankName: string;
  paymentType: null;
  remark: null;
  vipDate: null;
  roleIds: number[];
  pointValue: number;
  questionnaire: number;
  amount: null;
  employeeNumber: string;
  entryDate: null;
  basicSalary: number;
  idCard: string;
  birthday: null;
  clockType: null;
  serviceStatus: null;
  roleName: null;
  roleKey: null;
  isManager: null;
  sourceShopArray: any[];
  shopIds: any[];
  empFlag: null;
  keywords: null;
  dataSource: null;
  vipFlag: null;
  shopName: string;
  customerNumber: null;
  sendCoupon: number;
  customerIds: any[];
  progressBarScore: null;
  skill: null;
  certificates: any[];
  galleries: any[];
  importantContact: null;
  importantPhone: null;
  positionStatus: number;
  wxAccount: null;
  birthDayTimeType: null;
  admin: boolean;
}

interface Role {
  tenantId: null;
  createBy: null;
  createTime: null;
  updateBy: null;
  updateTime: null;
  params: any;
  roleId: number;
  roleName: string;
  roleKey: string;
  roleSort: string;
  dataScope: string;
  menuCheckStrictly: boolean;
  deptCheckStrictly: boolean;
  status: string;
  delFlag: null;
  flag: boolean;
  menuIds: any[];
  deptIds: any[];
  remark: null;
  admin: boolean;
}
interface UserResult {
    permissions: string[]
    roles: string[],
    user: UserInfo,
    tenantName: string
}

export const getUserInfo = (): Promise<UserResult> => {
    return request({
        url: '/getInfo',
        method: 'get'
    })
}


export const login = (data: {
    username: string, password: string, code?: string, uuid?: string, tenantId: string
}): Promise<LoginResult> => {
    return request({
        url: '/login',
        method: 'post',
        data: data,
        headers: {
            'X-Tenant-Id': data.tenantId,
        }
    })
}

export const getRouters = () => {
    return request({
        url: '/getRouters',
        method: 'get'
    })

}

export const getShopList = (params?:any) => {
    return request({
        url: '/shop/shopinfo/getApplyShopList',
        method: 'get',
        params
    })
}

export const getCustomer = (query?: string) => {
    return request({
        url: '/v4/business/member/list',
        method: 'get',
        params: {
            param: query
        }
    })
}

export const exportFile = (query: any, url: string, method = 'post'): Promise<any> => {
    return request({
        url,
        method,
        data: query
    })
}

export const exportFileget = (params: any, url: string, method = 'get'): Promise<any> => {
    return request({
        url,
        method,
        params:params
    })
}



/**
 * 修改密码-入参
 */
export interface PasswordReq {
  oldPassword: string
  newPassword: string
}
/** 修改密码 */
export const modifyPassword = (data: PasswordReq) =>
  request.put<UserInfo>(`/system/user/profile/updatePwd?oldPassword=${data.oldPassword}&newPassword=${data.newPassword}`)
